






























































































































































import Vue from 'vue'
import { MetaService } from '@/shared/services/meta-service'
import { Injector } from '@/config/dependency-injection'
import RespondecoPagination from '@/main/respondeco-pagination.vue'
import { OrganisationsModule } from '@/business/organisation/store/organisations-module'
import { FETCH_ORGANISATIONS, SEARCH_ORGANISATIONS } from '@/business/organisation/store/types'
import { StringMap } from '@/shared/utils/map'
import HeroSearchField from '@/shared/components/hero-search-field.vue'
import { KeyValuePair } from '@/shared/utils/key-value-pair'
import { LoaderHelper } from '@/shared/services/loader-helper'
import { BButton, BDropdown, BDropdownItem } from 'bootstrap-vue'
import RespondecoLoadingIndicator from '@/shared/components/respondeco-loading-indicator.vue'
import UnifyButton from '@/shared/components/unify/unify-button.vue'
import DefaultHeader from '@/main/default-header.vue'
import { shortenString } from '@/shared/utils/shorten-string'
import Component from 'vue-class-component'
import { SearchResultItem } from '@/shared/models/search-result-item'
import RespondecoSearchResults from '@/shared/components/respondeco-search-results.vue'
import RespondecoPager from '@/main/respondeco-pager.vue'
import RespondecoToolbar from '@/shared/components/toolbar/respondeco-toolbar.vue'
import { isDesktop } from '@/shared/utils/is-desktop'
import RespondecoFilterToggle from '@/shared/components/respondeco-filter-toggle.vue'

@Component({
  components: {
    RespondecoFilterToggle,
    RespondecoToolbar,
    RespondecoPager,
    RespondecoSearchResults,
    DefaultHeader,
    UnifyButton,
    RespondecoLoadingIndicator,
    'b-button': BButton,
    'b-dropdown': BDropdown,
    'b-dropdown-item': BDropdownItem,
    HeroSearchField,
    RespondecoPagination,
  },
})
export default class Organisations extends Vue {
  public filter: {
    canReset: boolean
    categories: StringMap<boolean>
    filterHasChanged: boolean
    organisationTypes: StringMap<boolean>
    query: string
    queryHasChanged: boolean
  } = {
    canReset: false,
    categories: {},
    filterHasChanged: false,
    organisationTypes: {},
    query: '',
    queryHasChanged: false,
  }

  public page = 1
  public pageSize = 10

  public shortenString = shortenString

  private loaderHelper = Injector.get(LoaderHelper)
  private metaService = Injector.get(MetaService)
  private organisationsModule = Injector.get(OrganisationsModule)

  public get isInitializing(): boolean {
    return this.loaderHelper.isLoading(FETCH_ORGANISATIONS)
  }

  public get isDesktop(): boolean {
    return isDesktop()
  }

  public get isSearching(): boolean {
    return this.loaderHelper.isLoading(SEARCH_ORGANISATIONS)
  }

  public get items() {
    return this.viewModel.organisations.items
  }

  public get lookupCategories(): Array<KeyValuePair<number, string>> {
    return this.viewModel.lookup.categories
  }

  public get lookupOrganisationsTypes(): Array<KeyValuePair<number, string>> {
    return this.viewModel.lookup.organisationTypes
  }

  public get organisations(): SearchResultItem[] {
    return this.viewModel.organisations.items
  }

  public get total() {
    return this.viewModel.organisations.total
  }

  public get viewModel() {
    return this.organisationsModule.organisationsViewModel
  }

  public created() {
    this.fetchViewModel(this.page, this.pageSize)
    this.metaService.updateDocumentTitle('organisations')
  }

  public changePageSize(pageSize: number) {
    this.page = 1
    this.pageSize = pageSize

    this.search()
  }

  /**
   * Fetch offers and lookup values
   */
  public fetchViewModel(page = this.page, pageSize = this.pageSize) {
    this.page = page
    this.pageSize = pageSize

    return this.organisationsModule
      .fetchOrganisations({
        page,
        pageSize,
      })
      .then(() => {
        this.initialiseFilters()
      })
  }

  /**
   * User selected another page
   */
  public pageChanged(page: number) {
    if (page !== this.page) {
      this.page = page

      this.search()
    }
  }

  /**
   * Reset filters
   */
  public resetFilters() {
    this.initialiseFilters()

    this.search().then(() => {
      this.filter.canReset = false
    })
  }

  /**
   * Search for offers
   */
  public search(query?: string) {
    if (query !== undefined) {
      this.filter.query = query
    }

    if (this.filter.filterHasChanged || this.filter.queryHasChanged) {
      this.page = 1
    }

    const categories = Object.entries(this.filter.categories)
      .filter(value => value[1])
      .map(value => Number(value[0]))

    const organisationTypes = Object.entries(this.filter.organisationTypes)
      .filter(value => value[1])
      .map(value => Number(value[0]))

    return this.organisationsModule
      .searchOrganisations({
        categories,
        organisationTypes,
        pageSize: this.pageSize,
        page: this.page,
        query: this.filter.query,
      })
      .then(() => {
        this.filter.canReset = true
        this.filter.filterHasChanged = false
        this.filter.queryHasChanged = false
      })
  }

  /**
   * User selected a category filter
   */
  public toggleCategory(key: string) {
    this.filter.categories[key] = !this.filter.categories[key]
    this.filter.filterHasChanged = true
  }

  /**
   * User selected an offer type filter
   * @param key
   */
  public toggleOrganisationType(key: string) {
    this.filter.organisationTypes[key] = !this.filter.organisationTypes[key]
    this.filter.filterHasChanged = true
  }

  private initialiseFilters() {
    const viewModel = this.viewModel

    this.filter.categories = {}
    this.filter.organisationTypes = {}

    for (const category of viewModel.lookup.categories) {
      this.$set(this.filter.categories, category.key, false)
    }

    for (const organisationType of viewModel.lookup.organisationTypes) {
      this.$set(this.filter.organisationTypes, organisationType.key, false)
    }
  }
}
